import { Injectable, signal } from '@angular/core';
import { Messages } from '../constants/messages';

export interface ConfirmDialogOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary';
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private dialogSignal = signal<ConfirmDialogOptions | null>(null);
  private resolver: ((accepted: boolean) => void) | null = null;

  public get dialog() {
    return this.dialogSignal.asReadonly();
  }

  public confirm(options: ConfirmDialogOptions | string): Promise<boolean> {
    this.resolve(false);
    const resolved: ConfirmDialogOptions =
      typeof options === 'string' ? { message: options } : options;
    this.dialogSignal.set({
      title: resolved.title ?? Messages.CONFIRM_TITLE,
      message: resolved.message,
      confirmLabel: resolved.confirmLabel ?? Messages.CONFIRM_ACCEPT,
      cancelLabel: resolved.cancelLabel ?? Messages.CONFIRM_CANCEL,
      variant: resolved.variant ?? 'danger',
    });
    return new Promise((resolve) => {
      this.resolver = resolve;
    });
  }

  public resolve(accepted: boolean): void {
    this.dialogSignal.set(null);
    this.resolver?.(accepted);
    this.resolver = null;
  }
}
